interface AttendanceFilterLocation {
  _id: string;
  location_name: string;
}

interface BuildAttendanceListParamsInput {
  page: number;
  filterLocation: string;
  filterClub: string;
  attendanceTypeFilter: 'all' | 'basic-training' | 'leadership-education';
  leadershipSessionFilter: string;
  attendanceFilterLocations: AttendanceFilterLocation[];
}

export const buildAttendanceListParams = ({
  page,
  filterLocation,
  filterClub,
  attendanceTypeFilter,
  leadershipSessionFilter,
  attendanceFilterLocations,
}: BuildAttendanceListParamsInput): Record<string, string> => {
  const params: Record<string, string> = {
    page: String(page),
    size: '50',
  };

  if (filterLocation && attendanceTypeFilter !== 'leadership-education') {
    if (filterLocation.startsWith('deleted-name:')) {
      const encodedLocationName = filterLocation.replace(/^deleted-name:/, '').split(':')[0] || '';
      const decodedLocationName = decodeURIComponent(encodedLocationName);
      if (decodedLocationName) params.bt_location_name = decodedLocationName;
    } else {
      params.bt_location_id = filterLocation;
      const selectedLocation = attendanceFilterLocations.find((location) => location._id === filterLocation);
      if (selectedLocation?.location_name) {
        params.bt_location_name = selectedLocation.location_name;
      }
    }
  }

  if (filterClub && attendanceTypeFilter !== 'leadership-education') {
    params.bt_club_id = filterClub;
  }
  if (attendanceTypeFilter !== 'all') {
    params.attendance_type = attendanceTypeFilter;
  }
  if (leadershipSessionFilter) {
    params.session_id = leadershipSessionFilter;
  }

  return params;
};
